<template>
  <div class="textarea">
    <span
      v-if="showLength && value"
      class="textarea__length"
      >{{ String(value).length }}</span
    >
    <textarea
      :value="c_value"
      class="textarea__textarea"
      :class="c_inputClass"
      :disabled="disabled"
      :rows="rows"
      :required="required"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <label class="textarea__label">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'VTextarea',
  props: {
    modelValue: {
      type: [Number, String, Boolean],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showLength: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: undefined,
    },
    rows: {
      type: [Number, String],
      default: 2,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: undefined,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    c_value: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    c_inputClass() {
      const res = [];
      if (this.c_value) {
        res.push('textarea__textarea_filled');
      }
      if (this.error) {
        res.push('textarea__textarea_error');
      }
      return res.join(' ');
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/base/scroll';

.textarea {
  background: none;
  font-size: 16px;
  position: relative;
}

.textarea__length {
  position: absolute;
  top: 7px;
  right: 7px;
  font-size: 12px;
  line-height: 12px;
  opacity: 0.3;
}

.textarea__textarea {
  background: white;
  outline: none !important;
  border: 1px solid $line-theme-fade;
  color: $foreground-contrast;
  appearance: none;
  font: $base-font;
  font-size: 16px;
  width: 100%;
  padding: 20px 15px 10px;
  min-height: 46px;
  border-radius: 10px;
  transition: border-color 0.25s;
  @include styled-scroll($foreground-theme);

  &:focus {
    border-color: $foreground-theme;
  }

  //&::placeholder {
  //    color: #CECECE;
  //    font-size: 16px;
  //}

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    font: $base-font !important;
  }
}

.textarea__label {
  font-weight: 300;
  margin-bottom: 0;
  display: inline-flex;
  white-space: nowrap;
  width: calc(100% - 16px);
  color: $foreground-gray;
  position: absolute;
  transition: all 0.1s linear;
  cursor: text;
  pointer-events: none;
  left: 15px;
  top: 11px;
}

.textarea__textarea:focus,
.textarea__textarea_filled {
  & + .textarea__label {
    font-size: 12px;
    top: 1px;
  }
}

.textarea__textarea_error {
  border-bottom: 2px solid $text-status-destructive;
  margin-bottom: -1px;
}
</style>
